import bg from '../assets/bg.png';
import chef from '../assets/chef-web.jpg';
import G from '../assets/G.png';
import knife from '../assets/knife.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import findus from '../assets/findus.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import takeSushiLogo from '../assets/TAKE_SUSHI_LOGO-transparent.png';
import assortment from '../assets/assortments.jpg'
import assortment2 from '../assets/assortment2.jpg'
import massSpicyCalifornia from '../assets/spicy-crab-roll.jpg'
import massRainbowRoll from '../assets/rainbow-roll.jpg'
import header from '../assets/header.jpg'
import coverphoto from '../assets/cover_photo.jpg'
import coverphoto2 from '../assets/cover_photo2.jpg'
import coverphoto3 from '../assets/cover_photo3.png'
import manager from '../assets/manager-web.jpg'
import sushi_menu from '../assets/sushi-menu.pdf'
import menu_screen from '../assets/menu_screen.jpg'

const images = {
  bg,
  chef,
  G,
  knife,
  menu,
  overlaybg,
  spoon,
  findus,
  sign,
  quote,
  takeSushiLogo,
  assortment,
  assortment2,
  massRainbowRoll,
  massSpicyCalifornia,
  header,
  coverphoto,
  coverphoto2,
  coverphoto3,
  manager,
  sushi_menu,
  menu_screen
};

export default images;
